export const getSicileData = () => ({
  name: "Sicile",
  country: "Italie",
  description: "La Sicile est la plus grande île viticole de la Méditerranée, produisant des vins puissants et des cépages autochtones uniques.",
  type: "region",
  mapAreas: [
    { region: "Sicile", x: 57, y: 68, color: "#4B164C", size: 7 }
  ],
  statistics: {
    totalArea: "98,000 ha",
    production: "4,200,000 hl",
    wineries: "500+ domaines",
    villages: "15+ communes",
    exportPercentage: "60%"
  },
  characteristics: {
    climate: "Climat méditerranéen chaud, étés très secs, influence maritime",
    soil: "Sols volcaniques (Etna), calcaires, argileux",
    viticulture: "Vignes en altitude, vendanges précoces, cépages autochtones"
  },
  wineStyles: {
    red: "Rouges puissants et fruités (Nero d'Avola, Etna Rosso)",
    white: "Blancs secs et minéraux (Grillo, Carricante)",
    dessert: "Marsala, Passito di Pantelleria, Malvasia"
  },
  history: "La Sicile produit du vin depuis l'Antiquité grecque. Le Marsala était le vin le plus exporté au XIXe siècle.",
  foodPairing: "Cuisine sicilienne, poissons méditerranéens, pâtes aux sardines, cannoli",
  subregions: {
    "etna": {
      name: "Etna",
      area: "1,200 ha",
      percentage: "1.2%",
      description: "Vins volcaniques d'altitude",
      characteristics: {
        climate: "Climat volcanique d'altitude",
        soil: "Sols volcaniques",
        viticulture: "Vendanges manuelles en altitude"
      },
      grapeVarieties: {
        red: ["Nerello Mascalese", "Nerello Cappuccio"],
        white: ["Carricante", "Catarratto"]
      },
      wineStyles: {
        red: "Rouges volcaniques et minéraux",
        white: "Blancs secs et minéraux"
      },
      foodPairing: "Poissons, fruits de mer, cuisine sicilienne"
    },
    "noto": {
      name: "Noto",
      area: "8,000 ha",
      percentage: "8.2%",
      description: "Nero d'Avola de qualité",
      characteristics: {
        climate: "Climat méditerranéen chaud",
        soil: "Sols calcaires",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Nero d'Avola", "Frappato"]
      },
      wineStyles: {
        red: "Rouges puissants et fruités"
      },
      foodPairing: "Viandes rouges, fromages affinés"
    },
    "marsala": {
      name: "Marsala",
      area: "4,500 ha",
      percentage: "4.6%",
      description: "Vins fortifiés traditionnels",
      characteristics: {
        climate: "Climat méditerranéen chaud",
        soil: "Sols calcaires",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Grillo", "Catarratto", "Inzolia"]
      },
      wineStyles: {
        dessert: "Vins fortifiés traditionnels"
      },
      foodPairing: "Desserts, fromages bleus, apéritifs"
    },
    "pantelleria": {
      name: "Pantelleria",
      area: "500 ha",
      percentage: "0.5%",
      description: "Vins doux naturels",
      characteristics: {
        climate: "Climat méditerranéen très chaud",
        soil: "Sols volcaniques",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Zibibbo"]
      },
      wineStyles: {
        dessert: "Vins doux naturels"
      },
      foodPairing: "Desserts, fruits secs, pâtisseries"
    },
    "cerasuolo-di-vittoria": {
      name: "Cerasuolo di Vittoria",
      area: "1,000 ha",
      percentage: "1.0%",
      description: "Rouges fruités",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols argileux",
        viticulture: "Vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Nero d'Avola", "Frappato"]
      },
      wineStyles: {
        red: "Rouges fruités et souples"
      },
      foodPairing: "Pâtes, viandes blanches, fromages frais"
    }
  },
  grapeVarieties: [
    { name: "Nero d'Avola", percentage: "25%", description: "Cépage rouge principal" },
    { name: "Grillo", percentage: "15%", description: "Cépage blanc du Marsala" },
    { name: "Catarratto", percentage: "20%", description: "Cépage blanc le plus planté" },
    { name: "Carricante", percentage: "8%", description: "Cépage blanc de l'Etna" },
    { name: "Nerello Mascalese", percentage: "12%", description: "Cépage rouge de l'Etna" },
    { name: "Autres", percentage: "20%", description: "Cépages autochtones" }
  ]
}); 